import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { KindAllNodeStoreContext } from './contexts/StoreContext'
import { KindAllNodeStoreProviderProps } from './interface'
import { createKindAllNodeStore } from './store/createStore'
import { KindAllNodeStoreUpdater } from './StoreUpdater'

export const KindAllNodeStoreProvider = <M extends boolean>({
  children,

  /* -------------------------------------------------------------------------- */
  /*                       KindAllNodeStoreUpdater Props                       */
  /* -------------------------------------------------------------------------- */
  multiple,
  value,
  onChange
}: PropsWithChildren<KindAllNodeStoreProviderProps<M>>) => {
  const store = useCreation(() => createKindAllNodeStore(), [])

  return (
    <KindAllNodeStoreContext value={store}>
      <KindAllNodeStoreUpdater
        multiple={multiple}
        value={value}
        onChange={onChange}
      />
      {children}
    </KindAllNodeStoreContext>
  )
}
